import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../services/auth';
import { formatTime } from '../../utils/formatTime';
import { Panel } from '../../components/design';

const CORE_API = '/api';

export default function ServerAuditSection({ serverId }) {
  const { fetchWithAuth } = useAuth();

  const { data: auditData } = useQuery({
    queryKey: ['servers', serverId, 'audit'],
    queryFn: () => fetchWithAuth(`${CORE_API}/servers/${serverId}/audit?limit=10`).then(r => r.json()),
    refetchInterval: 60000,
  });

  const entries = auditData?.audit || [];

  const detailsText = (details) => {
    if (!details) return '';
    if (typeof details === 'string') return details;
    try { return JSON.stringify(details); } catch { return String(details); }
  };

  return (
    <Panel title="Audit Activity">
      {entries.length === 0 ? (
        <p className="muted" style={{ fontSize: 14 }}>No audit activity for this server yet.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {entries.map((entry, idx) => (
            <div key={idx} className="flex items-start justify-between" style={{ padding: 12, borderRadius: 12, background: 'var(--glass)', border: '1px solid var(--glass-border)', gap: 12 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="flex items-center gap-2 flex-wrap">
                  <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-1)' }}>{entry.action}</span>
                  {entry.user_id && <span className="mono muted" style={{ fontSize: 10, padding: '2px 6px', borderRadius: 4, background: 'var(--surface)', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{entry.user_id}</span>}
                </div>
                {detailsText(entry.details) && (
                  <div className="mono muted" style={{ fontSize: 12, marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{detailsText(entry.details)}</div>
                )}
              </div>
              <span className="muted" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{entry.created_at ? formatTime(entry.created_at) : ''}</span>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
